const Description = ({ text }) => {
    return (
        <h2 className="text-semilarge mb-auto text-center font-display font-light italic text-primary-700">
            &ldquo;{text}&rdquo;
        </h2>
    )
}

export default Description
